<style>
.flex {
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
}
    .logo {
        height: 60px;
        align-items: center;
    justify-content: center;
    }
    
    .v-content{
        background: url(./../assets/img/bg.jpg) no-repeat center center fixed; 
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
        height: 100%;
    }
    .colorw {
        color: #fff;
    }
</style>

<template>
   <div class="bg">
    <div class="flex">
        
        <p class="display-3 font-weight-thin">
          <img src="./../assets/img/logo.png" alt="MyfirebaseLogo" class="logo" >
           <br><span class="colorw">Witaj w aplikacji</span><br>
            <v-btn v-if="$auth.user()" @click="logout()">Wyloguj się</v-btn>
        <v-btn v-else @click="$router.push('/login')">Zaloguj się</v-btn>
        </p>
        
    </div>
    </div>
</template>
<script>
export default {
    mounted () {
    this.$auth
      .check()
      .then(user => {})
      .catch(err => {})
  },
    data () {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// Welcome.vue?00a0a35a